// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-layout-header {
  padding: 1.25rem 8.75rem;
  min-height: 1.25rem;
  height: auto;
  z-index: 100;
}
.gyramais-layout-header > * {
  max-width: 1598px;
  margin: auto !important;
}
@media (max-width: 1600px) {
  .gyramais-layout-header {
    padding: var(--xxl-content-padding);
  }
}
@media (max-width: 1200px) {
  .gyramais-layout-header {
    padding: var(--xl-content-padding);
  }
}
@media (max-width: 768px) {
  .gyramais-layout-header {
    padding: var(--md-content-padding);
  }
}
.gyramais-layout-content {
  width: 100%;
  padding: var(--xxl-content-padding);
  background-color: #ffffff !important;
}
.gyramais-layout-content > * {
  max-width: 1598px;
  margin: auto !important;
}
@media (max-width: 1200px) {
  .gyramais-layout-content {
    padding: var(--xl-content-padding);
  }
}
@media (max-width: 768px) {
  .gyramais-layout-content {
    padding: var(--md-content-padding);
    padding-bottom: 3rem;
  }
}
.gyramais-layout-footer {
  padding: var(--xxl-content-padding);
  min-height: 1.25rem;
  height: auto;
  z-index: 100;
}
.gyramais-layout-footer > * {
  max-width: 1598px;
  margin: auto !important;
}
@media (max-width: 1200px) {
  .gyramais-layout-footer {
    padding: var(--xl-content-padding);
  }
}
@media (max-width: 768px) {
  .gyramais-layout-footer {
    padding: var(--md-content-padding);
  }
}
.gyramais-layout-sider {
  padding: 2rem 1rem;
  background-color: #ffffff;
  border-right: 1px solid #c9d3cc;
  z-index: 101;
}
`, "",{"version":3,"sources":["webpack://./src/components/sdk/Layout/styles.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,mBAAA;EACA,YAAA;EAEA,YAAA;AAAF;AALA;EAQI,iBAAA;EACA,uBAAA;AAAJ;AAGE;EAAA;IACE,mCAAA;EAAF;AACF;AAEE;EAAA;IACE,kCAAA;EACF;AACF;AACE;EAAA;IACE,kCAAA;EAEF;AACF;AACA;EACE,WAAA;EACA,mCAAA;EACA,oCAAA;AACF;AAJA;EAMI,iBAAA;EACA,uBAAA;AACJ;AAEE;EAAA;IACE,kCAAA;EACF;AACF;AACE;EAAA;IACE,kCAAA;IACA,oBAAA;EAEF;AACF;AACA;EACE,mCAAA;EACA,mBAAA;EACA,YAAA;EAEA,YAAA;AAAF;AALA;EAQI,iBAAA;EACA,uBAAA;AAAJ;AAGE;EAAA;IACE,kCAAA;EAAF;AACF;AAEE;EAAA;IACE,kCAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,YAAA;AADF","sourcesContent":[".gyramais-layout-header {\n  padding: 1.25rem 8.75rem;\n  min-height: 1.25rem;\n  height: auto;\n\n  z-index: 100;\n\n  > * {\n    max-width: @content-max-width;\n    margin: auto !important;\n  }\n\n  @media (max-width: @xxl-screen) {\n    padding: var(--xxl-content-padding);\n  }\n\n  @media (max-width: @xl-screen) {\n    padding: var(--xl-content-padding);\n  }\n\n  @media (max-width: @md-screen) {\n    padding: var(--md-content-padding);\n  }\n}\n\n.gyramais-layout-content {\n  width: 100%;\n  padding: var(--xxl-content-padding);\n  background-color: #ffffff !important;\n\n  > * {\n    max-width: @content-max-width;\n    margin: auto !important;\n  }\n\n  @media (max-width: @xl-screen) {\n    padding: var(--xl-content-padding);\n  }\n\n  @media (max-width: @md-screen) {\n    padding: var(--md-content-padding);\n    padding-bottom: 3rem;\n  }\n}\n\n.gyramais-layout-footer {\n  padding: var(--xxl-content-padding);\n  min-height: 1.25rem;\n  height: auto;\n\n  z-index: 100;\n\n  > * {\n    max-width: @content-max-width;\n    margin: auto !important;\n  }\n\n  @media (max-width: @xl-screen) {\n    padding: var(--xl-content-padding);\n  }\n\n  @media (max-width: @md-screen) {\n    padding: var(--md-content-padding);\n  }\n}\n\n.gyramais-layout-sider {\n  padding: 2rem 1rem;\n  background-color: #ffffff;\n  border-right: 1px solid #c9d3cc;\n\n  z-index: 101;\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
